export const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400" preserveAspectRatio="xMidYMid meet">
  <svg
    x="70"
    y="30"
    width="235"
    height="270"
    viewBox="0 0 228 246"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M120.62,0l-7.5,7.51L0,120.62l120.62,120.62-.11-30.12L30.02,120.62,120.62,30.02l54.75,54.75,30-.02L120.62,0Z"
      fill="{{HEADER_LINKS_COLOR}}"
    />
    <path
      d="M108.12,84.8c-8.01,0-14.5,6.49-14.5,14.49s6.49,14.49,14.5,14.49c5.82,0,11.08-3.48,13.34-8.85h101.93l-18.08-20.13h-97.19ZM123.81,109.48v20.12h97.22v-20.12h-97.22ZM131.57,134.15v111.9l20.12-20.13v-91.78h-20.12ZM162.36,134.15v81.12l20.13-20.13v-60.99h-20.13ZM193.15,134.15v50.32l20.13-20.13v-30.19h-20.13Z"
      fill="{{HEADER_LINKS_COLOR}}"
    />
  </svg>
  <text
    x="200"
    y="350"
    text-anchor="middle"
    dominant-baseline="alphabetic"
    fill="{{HEADER_LINKS_COLOR}}"
    font-family="'Barlow Condensed', BarlowCondensed-Regular, Inter, system-ui, sans-serif"
    font-size="{{LOGO_TEXT_SIZE}}"
  >{{LOGO_TEXT}}</text>
</svg>
`;
